import { locale } from 'services/locale/en-US';
import { languages } from 'services/locale';

export const initialState = { locale, lang: languages.EN };
